import clsx from 'clsx';
import React, { useEffect } from 'react';

import styles from './styles.module.scss';

// can add more positions as we support them
type position = 'bottomLeft' | 'bottomRight';

interface TooltipProps {
  action?: () => void;
  actionMessage?: string;
  isLaunchTooltip?: boolean;
  link?: React.ReactNode;
  loadDelay?: number;
  onClose?: () => void;
  message?: string;
  position?: position;
  parentSeparation?: string;
  showTooltip: boolean;
  tooltipId?: string;
  setShowTooltip?: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
}

const Tooltip = ({
  action,
  actionMessage,
  isLaunchTooltip,
  link,
  loadDelay,
  onClose,
  message,
  parentSeparation = '180%', // This is what we already had, can update in future
  position = 'bottomLeft',
  showTooltip,
  tooltipId,
  setShowTooltip,
  title,
}: TooltipProps) => {
  useEffect(() => {
    if (loadDelay && setShowTooltip) {
      setTimeout(() => setShowTooltip(true), loadDelay);
    }
  }, [loadDelay, setShowTooltip]);

  const separationStyle = {
    [position.startsWith('bottom') ? 'top' : 'bottom']: `${parentSeparation}`,
  };

  return (
    showTooltip && (
      <div
        id={tooltipId || `tooltip_${Math.random().toString(36).slice(-5)}`}
        className={clsx('Tooltip', styles[`${position}Position`])}
        style={separationStyle}
      >
        <div className="tooltip-container">
          <button className="close-button" onClick={onClose}></button>
          {title ? <div>{title}</div> : isLaunchTooltip && <div>NEW!</div>}
          {message && <div>{message}</div>}
          {link && <div>{link}</div>}
          {actionMessage && <a onClick={action || onClose}>{actionMessage}</a>}
        </div>
      </div>
    )
  );
};

export default Tooltip;
